
import React from 'react';
import { useParams } from 'react-router-dom';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { CoursesContent } from '@/components/admin/CoursesContent';
import { CourseProfile } from '@/components/admin/CourseProfile';

export default function Courses() {
  const { id } = useParams();
  
  return (
    <AdminLayout>
      {id ? <CourseProfile /> : <CoursesContent />}
    </AdminLayout>
  );
}
